import Helper from "./Helper";
import * as S from './../Vars/shares';
import SharesShared from "./SharesShared";

/**
 * Shares Filter Handler
 * ------------------------
 * - handles the Filter Data
 * - builds the filter Radio Buttons
 * - add's filtering click functionality
 */
class SharesFilters {
  constructor() {
  }

  filterParser(data){
    const colIndexs = [];
    data.forEach((row, index) => {
      if (index == 0) {
        row.forEach((col, index) => {
          // find indexes for current language values
          let c = col.split(" ");
          if (c.length > 1) {
            if (c[1].toLowerCase() == S.lang.toLowerCase()) {
              colIndexs.push(index);
            }
          } else {
            colIndexs.push(index);
          }
        });
      } else {
        const filter = {};
        // value rows
        row.forEach((col, index) => {
          switch (index) {
            case colIndexs[0]:
              filter.id = col;
              break;
            case colIndexs[1]:
              filter.label = col;
              break;
            case colIndexs[2]:
              filter.tileText = col;
            case colIndexs[3]:
              filter.afterNumString = col;
          }
          filter.min;
          filter.max;
        });
        if(filter.id){
          S.filtersArr.push(filter);
        }
      }
    });
    this.buildFilters();
  }

  buildFilters() {
    let currFilter;
    S.filtersArr.forEach((filter, index) => {
      const val = "filter-" + filter.id;
      const btn = document.createElement("div");
      Helper.addClass(btn, 'data-filter');
      const checked = index == 0 ? "checked" : "";
      const html = `<input type="radio" name="share-filter" value="${val}" id="${val}" ${checked}>
                    <label for="${val}">${filter.label}</label>`;
      btn.innerHTML = html;
      S.filterSContainer.append(btn);
      if(index == 0){
        currFilter = val;
      }
      btn.addEventListener("click", (e) => {
        this.filterClick(btn, "share-filter");
      });
    });
    Helper.addClass(S.sharesContainer, currFilter);
  }

  filterClick(btn, inputName) {
    const currentInput = btn.querySelector('input[name="' + inputName + '"]');
    const filters = [...document.querySelectorAll('input[name="' + inputName + '"]')];
    const infos = [...document.querySelectorAll(".share-info__filter-info")];
    const currFilter = currentInput.value;
    Helper.addClass(S.sharesContainer, currFilter);
    const currentOrder = document.querySelector('input[name="sorting"]:checked').value;
    filters.forEach((fi) => {
      const val = fi.id;
      if (currentInput == fi) {
        fi.checked = true;
      } else {
        fi.checked = false;
        Helper.removeClass(S.sharesContainer, val);
      }
    });
    infos.forEach((info) => {
      const isFilter = info.dataset.isFilter;
      if (isFilter == currFilter) {
        Helper.addClass(info, "active");
      } else {
        Helper.removeClass(info, "active");
      }
    });

    SharesShared.sort(currentOrder, currFilter);
  }


}

export default SharesFilters;
